import React from 'react';
import classNames from 'classnames';
import VideoPlayer from '@dazn/lp-web/src/components/VideoBanner/Videoplayer';
// import {CrossIcon} from '@dazn/lp-web/src/components/Icons/CrossIcon';
import styles from '@dazn/lp-web/src/components/VideoBanner/video-banner.module.css';
import {useVideoBannerContext} from '@dazn/lp-web/src/components/VideoBanner/VideoBannerContext';
import {IVideo} from '../../types';

interface VideoModalContentProps {
    url: IVideo;
}

const VideoModalContent: React.FC<VideoModalContentProps> = ({url}) => {
    const {isFullScreen} = useVideoBannerContext();
    return (
        <div
            id="modal_video"
            className={classNames(styles.videoModalContainer, styles.zIndex, {
                [styles.isFullscreen]: isFullScreen
            })}
        >
            <VideoPlayer url={url} />
        </div>
    );
};

export default VideoModalContent;
